import React, { Component } from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import { dotsDecorator as dotsDecoratorWide } from '../../constants/slidersAlt';
import { dotsDecorator } from '../../constants/sliders';
import { isLargeTabletOrSmaller } from '../../core/util/device/screen';
import { Viewport } from '~/components/useViewport';

const mapStateToProps = (state: any) => ({
  viewport: state.runtime.viewport,
});

type JoinUsSliderProps = {
  s?: any;
  viewport: Viewport;
};

class JoinUsSlider extends Component<JoinUsSliderProps> {
  render = () => (
    <Carousel
      cellSpacing={isLargeTabletOrSmaller(this.props.viewport.width) ? 20 : 40}
      className={this.props.s.joinSlider}
      dragging
      frameOverflow="visible"
      heightMode="max"
      initialSlideHeight={320}
      renderBottomCenterControls={
        isLargeTabletOrSmaller(this.props.viewport.width) ? dotsDecorator : dotsDecoratorWide
      }
      renderCenterLeftControls={() => null}
      renderCenterRightControls={() => null}
      slidesToShow={isLargeTabletOrSmaller(this.props.viewport.width) ? 1 : 2}
      swiping
    >
      <img alt="Solv employees collaborating around a table" src="images/careers/joinUs1.jpg" />

      <img alt="Solv goes skiing" src="images/careers/SolvSki.jpg" />

      <img alt="Solv team 2" src="images/careers/SolvField.JPG" />

      <img alt="The Solv team at a party" src="images/careers/joinUs2.jpg" />

      <img alt="The Solv team spending time together" src="images/careers/joinUs3.jpg" />

      <img alt="The Solv team playing sports" src="images/careers/joinUs4.jpg" />
    </Carousel>
  );
}

export default connect(mapStateToProps)(JoinUsSlider);
